import React from 'react';

const ComingSoonText = ({children, additionalclasses}) => {
    return (
        <div className={`items-center gap-[4px] rounded-[4px] custom-text-grey-900 poppins-regular text-[10px] lg:text-[12px] w-fit px-[4px] lg:px-[6px] truncate min-h-[18px] grid items-center justify-center custom-bg-grey-50 ${additionalclasses}`}>{children}</div>
    );
};

export default ComingSoonText;